// N11 (05/10/2026) — hộp "Chạy gì trên <bot>?" mở ngay trên trang Bot (nút "Chạy" của thẻ bot, nút "Chạy trên bot đã tick"). Thay lối cũ
// #/jobs/new. Ba nhóm: Kịch bản (sơ đồ — tìm theo tên trên máy chủ, đủ nhanh với 1.000+), Học trên bot (tên các bot đã chọn có, bỏ kb-…),
// Chuỗi kịch bản; cuối hộp ô "Hoặc gõ mong muốn để tạo kịch bản mới" → #/kich-ban?botIds=…&yeuCau=… (điền sẵn, KHÔNG tự bấm Tạo).
// Hộp KHÔNG BAO GIỜ tự chạy: chọn một dòng chỉ mở trang với bot chọn sẵn. Bấm Chạy 2 lần = 1 hộp; Esc / × / bấm ngoài / đổi trang đóng hộp.
import { api, buildQuery, errMsg } from "../api";
import { clear, h } from "../dom";
import { store } from "../store";
import { laMaKbSoDo } from "../ten-kb";
import { chamNhan } from "./kich-ban-nhan";

const MAX_YC = 5000;
const dem = (s: string): number => Array.from(s).length;
interface DongKb { id: string; ten: string; nhan: string; nenTang: string; soBuoc: number; trangThai: string }
interface DongChuoi { id: string; ten: string }

/** Mở hộp chọn cho các bot (đã lọc: mã bot có thật). Hộp đang mở → chỉ đưa con trỏ về hộp (không mở thêm). */
export function moHopChonKichBan(botIds: string[]): void {
  const dangMo = document.querySelector<HTMLElement>('[data-testid="chon-kb-hop"]');
  if (dangMo) { dangMo.querySelector<HTMLElement>('[data-testid="chon-kb-tim"]')?.focus(); return; }
  const ids = botIds.filter((id) => store.bots.has(id));
  if (!ids.length) return;
  const bots = ids.map((id) => store.bots.get(id)!);
  const qBot = `botIds=${ids.join(",")}`;
  const tieuDe = bots.length === 1 ? `Chạy gì trên ${bots[0]!.name}?` : `Chạy gì trên ${bots.length} bot?`;
  let song = true;

  const tim = h("input", { type: "search", maxlength: 200, placeholder: "Tìm kịch bản theo tên…", "aria-label": "Tìm kịch bản theo tên", autocomplete: "off", "data-testid": "chon-kb-tim", title: "Gõ một phần tên (gõ không dấu cũng được)" });
  const dsKb = h("div", { class: "chon-kb-ds" });
  const dsHoc = h("div", { class: "chon-kb-ds" });
  const dsChuoi = h("div", { class: "chon-kb-ds" });
  const nhom = (ma: string, ten: string, ds: HTMLElement, an = false): HTMLElement =>
    h("section", { class: "chon-kb-nhom", "data-testid": "chon-kb-nhom", dataset: { nhom: ma }, hidden: an }, h("h4", {}, ten), ds);
  const nhomHoc = nhom("hoc", "Học trên bot (chỉ chạy)", dsHoc, true);
  const nhomChuoi = nhom("chuoi", "Chuỗi kịch bản", dsChuoi, true);
  const mong = h("textarea", { rows: 3, maxlength: MAX_YC * 2, placeholder: "Ví dụ: Tìm bài về phần mềm kiến trúc trên Facebook rồi bình luận nhẹ nhàng 2 bài", "data-testid": "chon-kb-mong-muon", title: "Gõ mong muốn — trang Kịch bản mở ra với câu này điền sẵn, bạn bấm Tạo để AI viết" });
  const loi = h("p", { class: "err small", hidden: true, "data-testid": "chon-kb-loi" });
  const tao = h("button", { type: "button", class: "pri", "data-testid": "chon-kb-tao", title: "Mở trang Kịch bản với mong muốn này điền sẵn và bot đã chọn (chưa tạo, chưa chạy gì)" }, "Tạo kịch bản từ mong muốn này");
  const dong = (): void => { song = false; nen.remove(); document.removeEventListener("keydown", phim, true); };
  const nutX = h("button", { type: "button", class: "kb-noi-x", "aria-label": "Đóng hộp", title: "Đóng hộp (không chạy gì)", "data-testid": "chon-kb-dong-x", onclick: dong }, "×");
  const hop = h("div", { class: "modal chon-kb", role: "document", "data-testid": "chon-kb-hop" },
    h("div", { class: "row between chon-kb-dau" }, h("h3", { "data-testid": "chon-kb-tieu-de" }, tieuDe), nutX),
    bots.length > 1 ? h("p", { class: "small muted wrap" }, bots.map((b) => b.name).join(", ")) : null,
    h("p", { class: "small muted" }, "Chọn một kịch bản — trang kịch bản mở ra với bot đã chọn sẵn. Chưa chạy gì cho tới khi bạn bấm ▶ Chạy."),
    tim,
    h("div", { class: "chon-kb-cuon" }, nhom("so-do", "Kịch bản", dsKb), nhomHoc, nhomChuoi),
    h("div", { class: "chon-kb-moi" },
      h("label", { class: "f" }, h("span", {}, "Hoặc gõ mong muốn để tạo kịch bản mới"), mong),
      loi, h("div", { class: "row end" }, tao)));
  const nen = h("div", { class: "modal-wrap", role: "dialog", "aria-modal": "true", "aria-label": tieuDe, "data-testid": "chon-kb-nen" }, hop);
  nen.addEventListener("click", (e) => { if (e.target === nen) dong(); });
  nen.addEventListener("dong-hop", () => { song = false; document.removeEventListener("keydown", phim, true); }); // đổi trang / Esc toàn cục (dongHopTrang)
  function phim(e: KeyboardEvent): void { if (e.key === "Escape" && song) { e.preventDefault(); dong(); } }
  document.addEventListener("keydown", phim, true);
  document.body.appendChild(nen);
  tim.focus();

  const dongLink = (loai: string, href: string, ten: string, phu: (string | HTMLElement)[], data: Record<string, string>): HTMLAnchorElement => {
    const a = h("a", { class: "chon-kb-dong", href, "data-testid": "chon-kb-dong", dataset: { loai, ...data }, title: `Mở “${ten}” với bot đã chọn sẵn (chưa chạy gì)` },
      h("span", { class: "chon-kb-ten" }, ten), h("span", { class: "chon-kb-phu small muted" }, ...phu));
    a.addEventListener("click", () => dong());
    return a;
  };
  const trong = (cau: string): HTMLElement => h("p", { class: "muted small", "data-testid": "chon-kb-trong" }, cau);

  // ---- Kịch bản sơ đồ (máy chủ tìm theo tên — ?q=, 50 dòng đầu)
  let luot = 0;
  async function taiKb(): Promise<void> {
    const g = ++luot;
    const q = tim.value.trim();
    let items: DongKb[];
    try {
      items = (await api<{ items: DongKb[] }>("GET", `/api/kich-ban${buildQuery({ limit: 50, q: q || null, ownerId: store.user?.role === "super" ? bots[0]!.ownerId : null })}`)).items;
    } catch (e) {
      if (!song || g !== luot) return;
      clear(dsKb); dsKb.append(h("p", { class: "err small" }, `Không tải được kịch bản: ${errMsg(e)}`));
      return;
    }
    if (!song || g !== luot) return;
    clear(dsKb);
    const coSoDo = items.filter((k) => k.trangThai !== "dang_viet" && k.trangThai !== "loi_ai");
    if (!coSoDo.length) { dsKb.append(trong(q ? "Không có kịch bản nào khớp." : "Chưa có kịch bản nào.")); return; }
    for (const k of coSoDo) dsKb.append(dongLink("so-do", `#/kich-ban/${encodeURIComponent(k.id)}?${qBot}`, k.ten, [chamNhan(k.nhan, "chon-kb-nhan"), ` · ${k.soBuoc} bước`], { id: k.id }));
  }
  let hen: number | undefined;
  tim.addEventListener("input", () => { window.clearTimeout(hen); hen = window.setTimeout(() => { void taiKb(); veHoc(); }, 150); });
  void taiKb();

  // ---- Học trên bot: tên các bot đã chọn có (bỏ kb-…), lọc theo ô tìm
  function veHoc(): void {
    const dem2 = new Map<string, number>();
    for (const b of bots) for (const r of b.bundles) if (!laMaKbSoDo(r.name)) dem2.set(r.name, (dem2.get(r.name) ?? 0) + 1);
    const q = tim.value.trim().toLowerCase();
    const ten = [...dem2.keys()].filter((t) => !q || t.toLowerCase().includes(q)).sort((a, b) => a.localeCompare(b, "vi"));
    clear(dsHoc);
    nhomHoc.hidden = !dem2.size;
    if (!ten.length) { dsHoc.append(trong("Không có kịch bản nào khớp.")); return; }
    for (const t of ten) {
      const n = dem2.get(t)!;
      dsHoc.append(dongLink("hoc", `#/kich-ban/tu-bot/${encodeURIComponent(t)}?${qBot}`, t, [bots.length > 1 ? `có trên ${n}/${bots.length} bot` : "học trên bot — chỉ chạy"], { name: t }));
    }
  }
  veHoc();

  // ---- Chuỗi kịch bản
  void api<{ items: DongChuoi[] }>("GET", "/api/chuoi").then((r) => {
    if (!song) return;
    const ds = r.items ?? [];
    nhomChuoi.hidden = !ds.length;
    for (const c of ds) dsChuoi.append(dongLink("chuoi", `#/chuoi/${encodeURIComponent(c.id)}?${qBot}`, c.ten, ["chuỗi kịch bản"], { id: c.id }));
  }).catch(() => { /* không có chuỗi vẫn chọn được kịch bản */ });

  // ---- Mong muốn → trang Kịch bản điền sẵn
  tao.addEventListener("click", () => {
    loi.hidden = true;
    const t = mong.value.trim();
    if (!t) { loi.textContent = "Hãy gõ mong muốn (một vài câu: mạng nào, làm gì, bao nhiêu)"; loi.hidden = false; mong.focus(); return; }
    if (dem(t) > MAX_YC) { loi.textContent = `Mong muốn quá dài (tối đa ${MAX_YC} ký tự) — hãy rút gọn`; loi.hidden = false; mong.focus(); return; }
    dong();
    location.hash = `/kich-ban?${qBot}&${new URLSearchParams({ yeuCau: t }).toString()}`;
  });
}
